export default "__VITE_ASSET__BqMSfw1m__"